import { actionTypes } from '../actions/actions.action';
const initialState = {
    accounts: [],
    status: [],
    actions: {
        data: []
    },
    action: {
        fotos: []
    },
    search: {
        user: {},
        cota: {}
    },
    random: [],
    error: {},
    success: false
}

const actionsReducer = (state = initialState, { type, payload, isLoadMore, action_id }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.actions.data = state.actions.data.concat(payload.actions.data)
        }

        return { ...state, ...payload }

    case actionTypes.LOADING:
        let uid = state.actions.data.findIndex(item => item.id === payload.id)
        state.actions.data[uid].loading = payload.loading

        return { ...state, ...payload }

    case actionTypes.COUNT:
        let i = state.actions.data.findIndex(item => item.id === action_id)
        state.actions.data[i].pagos_count = payload.pagos_count;
        state.actions.data[i].reservados_count = payload.reservados_count
        state.actions.data[i].total_count = payload.total_count

        return {
            ...state
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            plus: (payload === 'clear') ? {
                title: null,
                primeiro: null,
                segundo: null,
                terceiro: null
            } : {
                ...state.plus,
                ...payload
            },
            action: (payload === 'clear') ? { fotos: [] } : {
                ...state.action,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default actionsReducer